var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"errors"}},[_c('Layout',{staticClass:"error"},[_c('Error',{staticClass:"error__page",attrs:{"message":_vm.message,"back":true}},[_c('h1',{staticClass:"error__name"},[_c('span',[_vm._v("4")]),_c('span',[_vm._v("0")]),_c('span',[_vm._v("4")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }